export enum InputBoxType {
  Input = 'input',
  Select = 'select',
  CustomTerms = 'customTerms',
  Paragraph = 'paragraph',
  Image='image'
}